'use strict';
const angular = require('angular');

export class editPropertyContactsComponent {
  constructor(ContactService, $uibModal) {
    'ngInject';

    this.$uibModal = $uibModal;
    this.contactTypes = [{
      value: "primary-owner",
      name: "Primary Owner"
    },{
      value: "owner",
      name: "Owner"
    },{
      value: "previous-owner",
      name: "Previous Owner"
    },{
      value: "renter",
      name: "Renter"
    },{
      value: "visitor",
      name: "Visitor"
    }];

    ContactService.query(data => {
      this.contacts = data.map(contact => {
        return {
          value: contact._id,
          name: this.getComposedName(contact)
        };
      });
    });
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.hasOwnProperty("contacts")) {
      let contacts = angular.copy(this.config.contacts);

      contacts.forEach(contactEntry => {
        if (contactEntry.contact)
          contactEntry.contact = contactEntry.contact._id;
        
        if (contactEntry.from)
          contactEntry.from = new Date(contactEntry.from);

        if (contactEntry.till)
          contactEntry.till = new Date(contactEntry.till);
      });

      this.contactEntries = contacts;
    }
  };

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += " (" + contact.company + ")";
    }

    return composedName || "-";
  }

  contactLookup(contact) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'contactLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      (contactEntry) => {
        contact.contact = contactEntry._id;
      },
      function () { /* cancel */ }
    );

  }

  ok() {
    this.close({$value: this.contactEntries});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  remove(idx) {
    this.contactEntries.splice(idx,1);
  }

  openDatePopup(contcat, ctx) {
    if (ctx == 'from')
      contcat.fromOpened = true;
    else
      contcat.tillOpened = true;
  }
}

export default angular.module('conduuApp.editPropertyContacts', [])
  .component('editPropertyContacts', {
    template: require('./edit-property-contacts.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: editPropertyContactsComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/edit-property-contacts/edit-property-contacts.component.js